import script from "./CardDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardDetail.vue?vue&type=script&setup=true&lang=ts"

import "./CardDetail.vue?vue&type=style&index=0&id=2a6dbc34&lang=scss"

const __exports__ = script;

export default __exports__